import { render } from "./Approver.vue?vue&type=template&id=4108563c&scoped=true&ts=true"
import script from "./Approver.vue?vue&type=script&lang=ts"
export * from "./Approver.vue?vue&type=script&lang=ts"

import "./Approver.vue?vue&type=style&index=0&id=4108563c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4108563c"]])

export default __exports__